module.exports = __webpack_public_path__ + "img/aerospace-explore.6e012263.jpg";